import { INIT, INIT_SUCCESS, INIT_FAILED, SAVE_SUCCESS, SAVE_FAILED, SAVE } from './constants';

export const initAction = (id: string): { type: typeof INIT; id: string } => ({
  type: INIT,
  id,
});
export const initSuccessAction = (): { type: string } => ({ type: INIT_SUCCESS });
export const initFailedAction = (
  error: Error,
  errorCode?: number
): { type: typeof INIT_FAILED; error: Error; errorCode?: number } => ({
  type: INIT_FAILED,
  error,
  errorCode,
});

export type FormData = {
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
  location: string;
  department: string;
  tShirtSize: string;
};
export const saveAction = (
  data: { id: string } & FormData
): { type: typeof SAVE; data: { id: string } & FormData } => ({
  type: SAVE,
  data,
});

export const saveSuccessAction = (data: unknown): { type: typeof SAVE_SUCCESS; data: unknown } => ({
  type: SAVE_SUCCESS,
  data,
});

export const saveFailedAction = (
  error: Error,
  errorCode: number,
  additional: object
): { type: typeof SAVE_FAILED; error: Error; errorCode: number } => ({
  type: SAVE_FAILED,
  error,
  errorCode,
  ...additional,
});
